export const EXECUTE_IMPACT_ANALYSIS = 'EXECUTE_IMPACT_ANALYSIS';
export const READ_CSA_SUMMARY = 'READ_CSA_SUMMARY';
export const READ_STATIC_DATA = 'READ_STATIC_DATA';
export const EXECUTE_WEB_JOBS = 'EXECUTE_WEB_JOBS';
